// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_a3afc74","nextArrow":"_06fcf9a","prevArrow":"_2fad3e4","slideImage":"_0e4574a","singleBanner":"_0db3004"};